import { Controller } from "@hotwired/stimulus"

// A shared display topic, separate from audience and visibility controls.
export default class extends Controller {
  static targets = ["select", "fields", "name", "group", "save", "status"]
  static values = { url: String, topics: Array }

  connect() {
    this.selected = this.selectTarget.value
    this.onTopicSaved = event => this.updateOption(event.detail)
    window.addEventListener("profile-topic:saved", this.onTopicSaved)
  }

  disconnect() {
    window.removeEventListener("profile-topic:saved", this.onTopicSaved)
  }

  change(event) {
    const action = this.selectTarget.value
    if (action === "__new" || action === "__edit") {
      event.stopPropagation()
      this.selectTarget.value = this.selected
      const topic = action === "__edit" ? this.topicsValue.find(topic => topic.value === this.selected) : null
      this.editing = topic?.value
      this.nameTarget.value = topic?.name || ""
      this.groupTarget.value = topic?.group || "business"
      this.statusTarget.textContent = ""
      this.fieldsTarget.hidden = false
      this.nameTarget.focus()
    } else {
      this.selected = action
      this.cancel()
      this.selectTarget.querySelector('[value="__edit"]').disabled = !action.startsWith("topic:")
    }
  }

  cancel() {
    this.fieldsTarget.hidden = true
    this.editing = null
  }

  async save(event) {
    event.preventDefault()
    const name = this.nameTarget.value.trim()
    if (!name) { this.statusTarget.textContent = "Enter a topic name."; this.nameTarget.focus(); return }
    const editing = this.editing
    this.saveTarget.disabled = true
    this.statusTarget.textContent = ""
    try {
      const url = editing ? `${this.urlValue}/${editing.slice(6)}` : this.urlValue
      const response = await fetch(url, {
        method: editing ? "PATCH" : "POST", credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json", "X-CSRF-Token": document.querySelector("meta[name=csrf-token]")?.content || "" },
        body: JSON.stringify({ profile_page_topic: { name, group: this.groupTarget.value } })
      })
      const data = await response.json()
      if (!response.ok || !data.ok) throw new Error(data.errors?.join(". ") || "Could not save the topic.")
      window.dispatchEvent(new CustomEvent("profile-topic:saved", { detail: data.topic }))
      this.selectTarget.value = data.topic.value
      this.selected = data.topic.value
      this.selectTarget.querySelector('[value="__edit"]').disabled = false
      this.cancel()
      this.selectTarget.dispatchEvent(new Event("change", { bubbles: true }))
    } catch (error) {
      this.statusTarget.textContent = error.message
    } finally {
      this.saveTarget.disabled = false
    }
  }

  updateOption(topic) {
    document.querySelectorAll(`[data-profile-topic="${CSS.escape(topic.value)}"]`).forEach(label => { label.textContent = topic.name })
    const topics = this.topicsValue.filter(item => item.value !== topic.value)
    this.topicsValue = [...topics, topic]
    let option = Array.from(this.selectTarget.options).find(option => option.value === topic.value)
    if (!option) {
      option = new Option(topic.name, topic.value)
      this.selectTarget.add(option, this.selectTarget.querySelector('[value="__new"]'))
    }
    option.textContent = topic.name
  }
}
